<template>
    <el-dialog
        :close-on-click-modal="false"
        :title="titleDialog"
        :visible="showDialog"
        @close="close"
        @open="create">
        <form
            autocomplete="off"
            @submit.prevent="submit">
            <div class="form-body">
                <div class="row">
                    <div class="col-md-6">
                        <div
                            :class="{'has-danger': errors.number}"
                            class="form-group">
                            <label class="control-label">RUC</label>
                            <!-- <el-input :disabled="form.is_update" v-model="form.number" :maxlength="11" dusk="number">
                                <el-button :disabled="form.is_update" type="primary" slot="append" :loading="loading_search" icon="el-icon-search" @click.prevent="searchSunat">
                                    SUNAT
                                </el-button>
                            </el-input> -->

                            <!-- apiperu -->
                            <x-input-service v-model="form.number"
                                             :identity_document_type_id="form.identity_document_type_id"
                                             @search="searchNumber"></x-input-service>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div :class="{'has-danger': errors.name}"
                             class="form-group">
                            <label class="control-label">Nombre de la Empresa</label>
                            <el-input
                                v-model="form.name"
                                
                                dusk="name">
                            </el-input>
                            <small
                                v-if="errors.name"
                                class="form-control-feedback"
                                v-text="errors.name[0]">
                            </small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="form.is_update"
                             :class="{'has-danger': (errors.subdomain || errors.uuid)}"
                             class="form-group">
                            <label class="control-label">
                                Nombre de Subdominio
                            </label>
                            <el-input
                                v-model="form.hostname"
                                :disabled="form.is_update"
                                dusk="name">
                            </el-input>
                        </div>
                        <div v-else
                             :class="{'has-danger': (errors.subdomain || errors.uuid)}"
                             class="form-group">
                            <label class="control-label">
                                Nombre de Subdominio
                            </label>
                            <el-input
                                v-model="form.subdomain"
                                dusk="subdomain">
                                <template slot="append">{{ url_base }}</template>
                            </el-input>
                            <small
                                v-if="errors.subdomain"
                                class="form-control-feedback"
                                v-text="errors.subdomain[0]">
                            </small>
                            <small
                                v-if="errors.uuid"
                                class="form-control-feedback"
                                v-text="errors.uuid[0]">
                            </small>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'has-danger' : errors.trade_name }">
                            <label class="control-label">
                                Nombre comercial
                            </label>
                            <el-input v-model="form.trade_name"></el-input>
                            <small v-if="errors.trade_name"
                                class="form-control-feedback"
                                v-text="errors.trade_name[0]"
                            ></small>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div :class="{'has-danger': errors.email}"
                             class="form-group">
                            <label class="control-label">
                                Correo de Acceso
                            </label>
                            <el-input
                                v-model="form.email"
                                :disabled="form.is_update"
                                dusk="email">
                            </el-input>
                            <small
                                v-if="errors.email"
                                class="form-control-feedback"
                                v-text="errors.email[0]">
                            </small>
                        </div>
                    </div>

                    <div v-if="!form.is_update"
                         class="col-md-6">
                        <div :class="{'has-danger': (errors.password)}"
                             class="form-group">
                            <label class="control-label">
                                Contraseña

                                <el-tooltip class="item" effect="dark" placement="top-start" v-if="regex_password_client">
                                    <i class="fa fa-info-circle"></i>
                                    <div slot="content">
                                        <strong>FORMATO DE CONTRASEÑA</strong><br/><br/>
                                        La contraseña debe contener al menos una letra minúscula.<br/>
                                        La contraseña debe contener al menos una letra mayúscula.<br/>
                                        La contraseña debe contener al menos un dígito.<br/>
                                        La contraseña debe contener al menos un carácter especial [@.$!%*#?&-].<br/>
                                    </div>
                                </el-tooltip>
                            </label>
                            <el-input
                                v-model="form.password"
                                :disabled="form.is_update"
                                dusk="password"
                                type="password"
                                show-password>
                            </el-input>
                            <small
                                v-if="errors.password"
                                class="form-control-feedback"
                                v-text="errors.password[0]">
                            </small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div :class="{'has-danger': errors.plan_id}"
                             class="form-group">
                            <label class="control-label">
                                Plan
                            </label>
                            <el-select
                                v-model="form.plan_id"
                                dusk="plan_id"
                                @change="getModules"
                            >
                                <el-option
                                    v-for="option in arrayPlans"
                                    :key="option.id"
                                    :label="option.name"
                                    :value="option.id"
                                    :disabled="!option.active">
                                </el-option>
                            </el-select>
                            <small
                                v-if="errors.plan_id"
                                class="form-control-feedback"
                                v-text="errors.plan_id[0]">
                            </small>
                        </div>
                    </div>
                    <template v-if="form.plan_id">
                        <div class="col-md-6">
                            <div class="form-group"
                                :class="{'has-danger': errors.price}"
                            >
                                <label class="control-label">
                                    Precio
                                </label>
                                <el-input :disabled="!EditPaymentClientPlan" v-model="form.price"></el-input>
                                <small
                                    v-if="errors.price"
                                    class="form-control-feedback"
                                    v-text="errors.price[0]">
                                </small>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group"
                                :class="{'has-danger': errors.period_id}"
                            >
                                <label class="control-label">Periodo</label>
                                <el-select v-model="form.period_id" placeholder="Selecciona un periodo">
                                    <el-option v-for="(period, index) in periods"
                                        :key="index"
                                        :label="period.name"
                                        :value="period.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-6" v-if="form.period_id">
                        <div class="form-group" >
                            <label class="control-label">Cant. de Meses</label>
                            <template v-for="(period, index) in periods"
                                v-if="period.id === form.period_id">
                                <el-input :value="period.number_months" disabled></el-input>
                            </template>                            
                        </div>
                    </div>
                    </template>

                    <div v-if="!form.is_update"
                         class="col-md-6">
                        <div :class="{'has-danger': errors.type}"
                             class="form-group">
                            <label class="control-label">
                                Perfil
                            </label>
                            <el-select
                                v-model="form.type"
                                :disabled="form.is_update">
                                <el-option
                                    v-for="option in types"
                                    :key="option.type"
                                    :label="option.description"
                                    :value="option.type">
                                </el-option>
                            </el-select>
                            <small
                                v-if="errors.type"
                                class="form-control-feedback"
                                v-text="errors.type[0]">
                            </small>
                        </div>
                    </div>


                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Logo</label>
                            <el-input v-model="form.logo"
                                        :readonly="true">
                                <el-upload slot="append"
                                            :data="{'type': 'logo'}"
                                            :headers="headers"
                                            :on-success="successUploadLogo"
                                            :show-file-list="false"
                                            :action="`/${resource}/upload`"
                                            accept="image/*"
                                            :before-upload="beforeUploadLogo"
                                            >
                                    <el-button icon="el-icon-upload"
                                                type="primary"></el-button>
                                </el-upload>
                            </el-input>
                            <div class="sub-title text-danger"><small>Se recomienda resoluciones 700x300</small>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-6 center-el-checkbox mt-4">
                        <div :class="{'has-danger': errors.locked_emission}"
                             class="form-group">
                            <el-checkbox
                                v-model="form.locked_emission"
                                :disabled="form.is_update">
                                Limitar emisión de documentos
                            </el-checkbox>
                            <br>
                            <small
                                v-if="errors.locked_emission"
                                class="form-control-feedback"
                                v-text="errors.locked_emission[0]">
                            </small>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12 col-lg-4">
                        <label class="control-label">País</label>
                        <el-select v-model="form.country_id"
                            placeholder="Selecciona país"
                            filterable
                            :disabled="recordId"
                        >
                            <el-option v-for="(country, index) in countries"
                            :key="index"
                            :label="country.description"
                            :value="country.id"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="col-12 col-lg-4">
                        <label class="control-label">Departamento</label>
                        <el-select v-model="form.department_id"
                            placeholder="Selecciona departamento"
                            filterable
                            :disabled="recordId"
                            @change="filterProvince"
                        >
                            <el-option v-for="(department, index) in departments"
                            :key="index"
                            :label="department.description"
                            :value="department.id"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="col-12 col-lg-4">
                        <label class="control-label">Provincia</label>
                        <el-select v-model="form.province_id"
                            placeholder="Selecciona provincia"
                            filterable
                            :disabled="recordId"
                            @change="filterDistrict"
                        >
                            <el-option v-for="(province, index) in provinces"
                            :key="index"
                            :label="province.description"
                            :value="province.id"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="col-12 col-lg-4">
                        <label class="control-label">Distrito</label>
                        <el-select v-model="form.district_id"
                            placeholder="Selecciona país"
                            filterable
                            :disabled="recordId"
                        >
                            <el-option v-for="(district, index) in districts"
                            :key="index"
                            :label="district.description"
                            :value="district.id"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="col-12 col-lg-8">
                        <label class="control-label">Dirección Fiscal</label>
                        <el-input v-model="form.address" placeholder="Ingrese dirección fiscal"
                            :disabled="recordId"
                        ></el-input>
                    </div>
                </div>

                <div class="row mb-3" v-if="!recordId">
                    <!-- <div class="col-12">
                        <div class="form-group">
                            <el-checkbox label="Generar boleta de prueba"
                                v-model="form.generate_test_invoice"
                            ></el-checkbox>
                        </div>
                    </div> -->
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <el-checkbox label="Eliminar serie de Factura"
                                v-model="form.delete_invoice_series"
                            ></el-checkbox>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <el-checkbox label="Eliminar serie de Boleta"
                                v-model="form.delete_ticket_series"
                            ></el-checkbox>
                        </div>
                    </div>
                </div>
                
                <div class="row mb-3">
                    <div class="col-12 col-lg-6">
                        <div class="form-group"
                            :class="{'has-danger': errors.user_id}"
                        >
                            <label class="control-label">Creador del sistema</label>
                            <el-select v-model="form.user_id" placeholder="Selecciona un usuario">
                                <el-option v-for="(user, index) in users"
                                    :key="index"
                                    :label="user.name"
                                    :value="user.id"
                                ></el-option>
                            </el-select>
                            <small
                                v-if="errors.user_id"
                                class="form-control-feedback"
                                v-text="errors.user_id[0]">
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label class="control-label">Vendedor</label>
                            <el-select v-model="form.seller_id" placeholder="Selecciona un vendedor">
                                <el-option v-for="(seller, index) in sellers"
                                    :key="index"
                                    :label="seller.name"
                                    :value="seller.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <el-collapse
                    v-model="collapse">
                    <el-collapse-item
                        name="1"
                        title="Módulos">
                        <div class="row"
                            v-loading="loading_get_modules"
                        >
                            <span class="ml-4">Giro de negocio <small>(opcional)</small></span>
                            <div class="col-12">
                                <el-radio-group v-model="business" @change="changeModules">
                                    <el-radio :label="1">Básico</el-radio>
                                    <el-radio :label="2">Farmacia</el-radio>
                                    <el-radio :label="3">Hotel</el-radio>
                                    <el-radio :label="4">Restaurante</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="col-md-6">
                                <span>
                                    Habilitar módulos
                                </span>
                                <div class="form-group tree-container-admin">
                                    <el-tree
                                        ref="tree"
                                        :check-strictly="true"
                                        :data="modules"
                                        :props="defaultProps"
                                        accordion
                                        highlight-current
                                        node-key="id"
                                        show-checkbox
                                        @check="FixChildren">
                                    </el-tree>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <span>
                                    Habilitar apps
                                </span>
                                <div class="form-group tree-container-admin">
                                    <el-tree
                                        ref="Apptree"
                                        :check-strictly="true"
                                        :data="apps"
                                        :props="defaultAppsProps"
                                        accordion
                                        highlight-current
                                        node-key="id"
                                        show-checkbox
                                        @check="FixAppChildren">
                                    </el-tree>
                                </div>
                            </div>
                            <div class="col-md-6 center-el-checkbox mt-4">
                                <div :class="{'has-danger': errors.enable_list_product}"
                                    class="form-group">
                                    <el-checkbox
                                        v-model="form.enable_list_product">
                                        Habilitar multiples listas de precios por producto
                                    </el-checkbox>
                                    <br>
                                    <small
                                        v-if="errors.enable_list_product"
                                        class="form-control-feedback"
                                        v-text="errors.enable_list_product[0]">
                                    </small>
                                </div>
                            </div>
                        </div>

                    </el-collapse-item>

                    <el-collapse-item name="2">
                        <template slot="title">
                            Datos del cliente
                            <el-tooltip content="Puede ingresar opcionalmente los datos: El sistema no utilizará esta información para su funcionamiento, simplemente podrá almacenar datos para acceder a ellos fácilmente más adelante."
                                placement="top"
                            >
                                <i class="fa fa-info-circle ml-2"></i>
                            </el-tooltip>
                        </template>
                        <div class="row mt-2">
                            <div class="col-12">
                                Clave SOL:
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        Usuario SOL
                                    </label>
                                    <el-input v-model="form.user_sol"
                                        placeholder="Ingresar Usuario SOL"
                                    ></el-input>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        Contraseña SOL
                                    </label>
                                    <el-input v-model="form.password_sol"
                                        placeholder="Ingresar Contraseña SOL"
                                    ></el-input>
                                </div>
                            </div>
                            <div class="col text-center">
                                <span>CDT.pfx</span>
                                <template v-if="recordId && form.pfx">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.pfx)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadPfx"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'pfx'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadPfx"
                                    :on-remove="removePfx"
                                    :file-list="fileListPfx"
                                    :limit="1"
                                    :before-upload="beforeUploadPfx"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col text-center">
                                <span>CDT.pem</span>
                                <template v-if="recordId && form.pem">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.pem)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadPem"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'pem'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadPem"
                                    :on-remove="removePem"
                                    :file-list="fileListPem"
                                    :limit="1"
                                    :before-upload="beforeUploadPem"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col text-center">
                                <span>CDT.key</span>
                                <template v-if="recordId && form.key">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.key)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadKey"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'key'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadKey"
                                    :on-remove="removeKey"
                                    :file-list="fileListKey"
                                    :limit="1"
                                    :before-upload="beforeUploadKey"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col text-center">
                                <span>CDT.cer</span>
                                <template v-if="recordId && form.cer">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.cer)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadCer"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'cer'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadCer"
                                    :on-remove="removeCer"
                                    :file-list="fileListCer"
                                    :limit="1"
                                    :before-upload="beforeUploadCer"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col text-center">
                                <span>Ficha RUC</span>
                                <template v-if="recordId && form.ficha">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.ficha)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadFicha"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'ficha'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadFicha"
                                    :on-remove="removeFicha"
                                    :file-list="fileListFicha"
                                    :limit="1"
                                    :before-upload="beforeUploadFicha"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col text-center">
                                <span>CDT.p12</span>
                                <template v-if="recordId && form.p12">
                                    <span class="text-primary ml-2"
                                        @click="downloadFile(form.p12)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </span>
                                </template>
                                <el-upload
                                    ref="uploadP12"
                                    :action="`/${resource}/upload`"
                                    :data="{'type': 'p12'}"
                                    :headers="headers"
                                    :multiple="false"
                                    :on-success="successUploadP12"
                                    :on-remove="removeP12"
                                    :file-list="fileListP12"
                                    :limit="1"
                                    :before-upload="beforeUploadP12"
                                >
                                  <el-button slot="trigger" size="small" type="primary">Subir</el-button>
                                </el-upload>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-lg-8 mt-4"">
                                        <div class="form-group">
                                            <el-checkbox v-model="p12_to_pfx"
                                                label="Convertir .p12 a formato .pfx (se obtendrá el .cer y .key)"
                                            ></el-checkbox>
                                        </div>
                                    </div>
                                    <template v-if="p12_to_pfx">
                                        <div class="col-12 col-lg-4">
                                            <div class="form-gruop">
                                                <label class="control-label">
                                                    Contraseña certificado
                                                </label>
                                                <el-input v-model="password_p12_to_pfx" placeholder=""></el-input>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-2">
                                            <el-button type="primary"
                                                @click="convertP12ToPfx"
                                                :loading="loading_convert_p12_to_pfx"
                                            >
                                                Convertir
                                            </el-button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="control-label">
                                        Contraseña CDT
                                    </label>
                                    <textarea class="form-control"
                                        v-model="form.password_cdt"
                                        placeholder="Ingresar Contraseña CDT"></textarea>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="control-label">
                                        Observaciones
                                    </label>
                                    <textarea class="form-control"
                                        v-model="form.observations"
                                        placeholder="Ingresar Observaciones"></textarea>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>

                    <el-collapse-item name="7">
                        <template slot="title">
                            Limites
                        </template>
                    <div class="row">   
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-danger': errors.limit_users || errorLUser.limit_users}">
                                <label class="control-label">Límite de usuarios</label>
                                <el-input v-model="limit_users" @input="validateLUsers"  :disabled="form.users_unlimited || limitsDisabled"></el-input>
                                <el-checkbox v-model="form.users_unlimited" @change="setUnlimitUsers"
                                    :disabled="limitsDisabled"
                                >Ilimitado</el-checkbox><br>
                                <small class="form-control-feedback d-block" v-if="errors.limit_users" v-text="errors.limit_users[0]"></small>
                                <small class="form-control-feedback" v-if="errorLUser.limit_users" v-text="errorLUser.limit_users[0]"></small> 
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-danger': errors.limit_documents || errorLDocument.limit_documents}">
                                <label class="control-label">Límite de documentos
                                    <el-tooltip class="item"
                                                :content="form.include_sale_notes_limit_documents ? 'Cantidad factura, boleta, nota de crédito, nota de débito y nota de venta' : 'Cantidad factura, boleta, nota de crédito y débito'"
                                                effect="dark"
                                                placement="top">
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                                <el-input v-model="limit_documents" @input="validateLDocuments" :disabled="form.documents_unlimited || limitsDisabled"></el-input>
                                <el-checkbox v-model="form.documents_unlimited" @change="setUnlimitDocuments"
                                    :disabled="limitsDisabled"
                                >Ilimitado</el-checkbox><br>

                                <el-checkbox v-model="form.include_sale_notes_limit_documents"
                                    :disabled="limitsDisabled"
                                >Incluir notas de venta</el-checkbox><br>

                                <small class="form-control-feedback d-block" v-if="errors.limit_documents" v-text="errors.limit_documents[0]"></small>
                                <small class="form-control-feedback" v-if="errorLDocument.limit_documents" v-text="errorLDocument.limit_documents[0]"></small>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-danger': errors.establishments_limit}">
                                <label class="control-label">Límite de establecimientos</label>

                                <template v-if="form.establishments_unlimited">
                                    <el-input value="∞" disabled></el-input>
                                </template>
                                <template v-else>
                                    <el-input v-model="form.establishments_limit"
                                        :disabled="limitsDisabled"
                                    ></el-input>
                                </template>

                                <el-checkbox v-model="form.establishments_unlimited"
                                    :disabled="limitsDisabled"
                                >Ilimitado</el-checkbox><br>

                                <small class="form-control-feedback d-block" v-if="errors.establishments_limit" v-text="errors.establishments_limit[0]"></small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-danger': errors.sales_limit}">
                                <label class="control-label">
                                    Límite de ventas mensual
                                    <el-tooltip class="item"
                                                :content="form.include_sale_notes_sales_limit ? 'Monto (S/.) factura, boleta, nota de crédito, nota de débito y nota de venta' : 'Monto (S/.) factura, boleta, nota de crédito y débito'"
                                                effect="dark"
                                                placement="top">
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>

                                <template v-if="form.sales_unlimited">
                                    <el-input value="∞" disabled></el-input>
                                </template>
                                <template v-else>
                                    <el-input v-model="form.sales_limit"
                                        :disabled="limitsDisabled"
                                    ></el-input>
                                </template>

                                <el-checkbox v-model="form.sales_unlimited"
                                    :disabled="limitsDisabled"
                                >Ilimitado</el-checkbox><br>
                                <el-checkbox v-model="form.include_sale_notes_sales_limit"
                                    :disabled="limitsDisabled"
                                >Incluir notas de venta</el-checkbox><br>


                                <small class="form-control-feedback d-block" v-if="errors.sales_limit" v-text="errors.sales_limit[0]"></small>
                            </div>
                        </div>
                    </div>
                    </el-collapse-item>

                    <el-collapse-item
                        name="3"
                        title="Entorno del sistema">
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.soap_send_id}"
                                     class="form-group">
                                    <label class="control-label">
                                        SOAP Envio
                                    </label>
                                    <el-select
                                        v-model="form.soap_send_id"
                                        @change="changeSoapSend">
                                        <el-option
                                            v-for="(option, index) in soap_sends"
                                            :key="index"
                                            :label="option.text"
                                            :value="option.value">
                                        </el-option>
                                    </el-select>
                                    <small
                                        v-if="errors.soap_send_id"
                                        class="form-control-feedback"
                                        v-text="errors.soap_send_id[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.soap_type_id}"
                                     class="form-group">
                                    <label class="control-label">
                                        SOAP Tipo
                                    </label>
                                    <el-select
                                        v-model="form.soap_type_id"
                                        @change="changeSoapSend">
                                        <el-option
                                            v-for="option in soap_types"
                                            :key="option.id"
                                            :label="option.description"
                                            :value="option.id">
                                        </el-option>
                                    </el-select>

                                    <el-checkbox
                                        v-if="form.soap_send_id == '02' && form.soap_type_id == '01'"
                                        v-model="toggle"
                                        label="Ingresar Usuario">
                                    </el-checkbox>
                                    <small
                                        v-if="errors.soap_type_id"
                                        class="form-control-feedback"
                                        v-text="errors.soap_type_id[0]">
                                    </small>
                                </div>
                            </div>
                        </div>
                        <template v-if="form.soap_type_id == '02' || toggle == true ">
                            <div class="row">
                                <div class="col-md-12 mt-2">
                                    <h4 class="border-bottom">
                                        Usuario Secundario Sunat
                                    </h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div :class="{'has-danger': errors.soap_username}"
                                         class="form-group">
                                        <label class="control-label">
                                            SOAP Usuario
                                            <span class="text-danger">*</span>
                                        </label>
                                        <el-input
                                            v-model="form.soap_username">
                                        </el-input>
                                        <div class="sub-title text-muted">
                                            <small>
                                                RUC + Usuario. Ejemplo: 01234567890ELUSUARIO
                                            </small>
                                        </div>
                                        <small
                                            v-if="errors.soap_username"
                                            class="form-control-feedback"
                                            v-text="errors.soap_username[0]">
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div :class="{'has-danger': errors.soap_password}"
                                         class="form-group">
                                        <label class="control-label">
                                            SOAP Password
                                            <span class="text-danger">*</span>
                                        </label>
                                        <el-input
                                            v-model="form.soap_password">
                                        </el-input>
                                        <small
                                            v-if="errors.soap_password"
                                            class="form-control-feedback"
                                            v-text="errors.soap_password[0]">
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="form.soap_send_id == '02'"
                             class="row">
                            <div class="col-md-12">
                                <div :class="{'has-danger': errors.soap_url}"
                                     class="form-group">
                                    <label class="control-label">
                                        SOAP Url
                                    </label>
                                    <el-input
                                        v-model="form.soap_url"
                                        :disabled="true">
                                    </el-input>
                                    <small
                                        v-if="errors.soap_url"
                                        class="form-control-feedback"
                                        v-text="errors.soap_url[0]">
                                    </small>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-4">
                                <div :class="{'has-danger': errors.password_certificate}"
                                     class="form-group">
                                    <label class="control-label">
                                        Contraseña certificado
                                    </label>
                                    <el-input
                                        v-model="form.password_certificate"
                                        @blur="assignExpirationDate"
                                    >
                                    </el-input>
                                    <small
                                        v-if="errors.password_certificate"
                                        class="form-control-feedback"
                                        v-text="errors.password_certificate[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div :class="{'has-danger': errors.certificate}"
                                     class="form-group">
                                    <label class="control-label">
                                        Certificado pfx
                                    </label>
                                    <el-upload
                                        ref="upload"
                                        :action="`/${resource}/upload`"
                                        :data="{'type': 'certificate', 'password': form.password_certificate, 'soap_type_id': form.soap_type_id}"
                                        :headers="headers"
                                        :multiple="false"
                                        :on-error="errorUpload"
                                        :on-success="successUpload"
                                        :show-file-list="false">
                                        <el-button slot="trigger"
                                                   type="primary">
                                            Selecciona un archivo
                                        </el-button>
                                    </el-upload>
                                    <small
                                        v-if="errors.certificate"
                                        class="form-control-feedback"
                                        v-text="errors.certificate[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-12 col-md-5" v-if="form.soap_type_id == '02'">
                                <div class="form-group">
                                    <label class="control-label">
                                        Vencimiento de Certificado
                                    </label>
                                    <el-date-picker v-model="form.certificate_due"
                                        type="date"
                                        :clearable ="true"
                                        value-format="yyyy-MM-dd"
                                    ></el-date-picker>
                                </div>
                            </div>
                            <div v-show="form.is_update == false && certificate_admin"
                                 class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">
                                        Archivo cargado (Administrador)
                                    </label>
                                    <el-input
                                        v-model="certificate_admin"
                                        :disabled="true">
                                    </el-input>

                                </div>
                            </div>
                            <div
                                 class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        Archivo cargado (Cliente) {{ form.certificate ? '(1)' : '(0)' }}
                                    </label>
                                    <el-input
                                        v-model="form.certificate"
                                        :disabled="true">
                                    </el-input>

                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                    <!-- Configuracion de correo -->

                    <el-collapse-item name="4"
                        title="Configuración del sistema"
                    >
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header bg-info mb-0 card-header-no-radius">
                                        <h5 class="my-0">Consulta integrada de CPE - Validador de documentos
                                            <el-tooltip class="item"
                                                        content="Obtener los datos desde el portal de Sunat"
                                                        effect="dark"
                                                        placement="top-start">
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </h5>
                                    </div>
                                    <div class="card-body mt-0 card-body-no-radius">
                                        <div class="row">
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client ID</label>
                                                    <el-input v-model="form.integrated_query_client_id"
                                                        placeholder="Ingrese Client ID"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client Secret (Clave)</label>
                                                    <el-input v-model="form.integrated_query_client_secret"
                                                        placeholder="Ingrese Client Secret"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header bg-info mb-0 card-header-no-radius">
                                        <h5 class="my-0">Guías electrónicas</h5>
                                    </div>
                                    <div class="card-body mt-0 card-body-no-radius">
                                        <div class="row">
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client ID</label>
                                                    <el-input v-model="form.api_sunat_id"
                                                        placeholder="Ingrese Client ID"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client Secret (Clave)</label>
                                                    <el-input v-model="form.api_sunat_secret"
                                                        placeholder="Ingrese Client Secret"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header bg-info mb-0 card-header-no-radius">
                                        <h5 class="my-0">SIRE</h5>
                                    </div>
                                    <div class="card-body mt-0 card-body-no-radius">
                                        <div class="row">
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client ID</label>
                                                    <el-input v-model="form.sire_client_id"
                                                        placeholder="Ingrese Client ID"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label">Client Secret (Clave)</label>
                                                    <el-input v-model="form.sire_client_secret"
                                                        placeholder="Ingrese Client Secret"
                                                        :disabled="recordId"
                                                    ></el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>

                    <el-collapse-item name="5"
                                      title="Configuracion de correo">
                        <div class="row">
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.smtp_host}"
                                     class="form-group">
                                    <label class="control-label">
                                        Dirección del host de correo
                                    </label>
                                    <el-input
                                        v-model="form.smtp_host">
                                    </el-input>
                                    <small
                                        v-if="errors.smtp_host"
                                        class="form-control-feedback"
                                        v-text="errors.smtp_host[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.smtp_port}"
                                     class="form-group">
                                    <label class="control-label">
                                        Puerto del host de correo
                                    </label>
                                    <el-input
                                        v-model="form.smtp_port">
                                    </el-input>
                                    <small
                                        v-if="errors.smtp_port"
                                        class="form-control-feedback"
                                        v-text="errors.smtp_port[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.smtp_user}"
                                     class="form-group">
                                    <label class="control-label">
                                        Nombre de usuario de correo
                                    </label>
                                    <el-input
                                        v-model="form.smtp_user">
                                    </el-input>
                                    <small
                                        v-if="errors.smtp_user"
                                        class="form-control-feedback"
                                        v-text="errors.smtp_user[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.smtp_password}"
                                     class="form-group">
                                    <label class="control-label">
                                        Contraseña del usuario de correo
                                    </label>
                                    <el-input
                                        v-model="form.smtp_password"
                                        dusk="password"
                                        type="password">
                                    </el-input>
                                    <small
                                        v-if="errors.smtp_password"
                                        class="form-control-feedback"
                                        v-text="errors.smtp_password[0]">
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.smtp_encryption}"
                                     class="form-group">
                                    <label class="control-label">
                                        Encriptación de correo
                                    </label>
                                    <el-input
                                        v-model="form.smtp_encryption">
                                    </el-input>
                                    <small
                                        v-if="errors.smtp_encryption"
                                        class="form-control-feedback"
                                        v-text="errors.smtp_encryption[0]">
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group p-t-20">
                                    <a
                                        :href="'https://docs.google.com/document/d/1ix2vPsiqSoK9jNAOF2gPjWhNa3BdajU5x8I5aBvEz0o/edit?usp=sharing'"
                                        class="control-label"
                                        target="_new"
                                    >
                                        Para correos Gmail verificar el manual
                                    </a>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                    <!-- Configuracion de correo -->

                    <el-collapse-item name="6"
                        title="Información de contacto"
                    >
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        Nombre del cliente
                                    </label>
                                    <el-input v-model="form.contact_name"></el-input>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group"
                                    :class="{'has-danger': errors.contact_email}"
                                >
                                    <label class="control-label">
                                        Correo de contacto
                                    </label>
                                    <el-input v-model="form.contact_email"></el-input>
                                    <small v-if="errors.contact_email"
                                        class="form-control-feedback"
                                        v-text="errors.contact_email[0]"
                                    ></small>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group"
                                    :class="{'has-danger': errors.contact_whatsapp}"
                                >
                                    <label class="control-label">
                                        Número de WhatsApp
                                    </label>
                                    <el-input v-model="form.contact_whatsapp"></el-input>
                                    <small v-if="errors.contact_whatsapp"
                                        class="form-control-feedback"
                                        v-text="errors.contact_whatsapp[0]"
                                    ></small>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>

                <div class="row">
                    <div class="col-md-6 center-el-checkbox mt-4">
                        <div class="form-group">
                            <el-checkbox
                                v-model="form.config_system_env">
                                ¿ Permitir a la empresa cambiar la configuración de producción ?
                            </el-checkbox>
                            <br>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="recordId">
                    <div class="col-md-6 conter-el-checkbox mt-4">
                        <div class="form-group">
                            <el-checkbox
                                v-model="form.configuration_missing_data"
                            >
                                Falta terminar de configurar
                            </el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="form.configuration_missing_data" style="height: auto;">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="control-label">Observaciones de configuración faltante</label>
                            <el-input type="textarea"
                                :rows="2"
                                v-model="form.observations_configuration_missing_data"
                                placeholder="Ingresar Observaciones de configuración faltante"
                                style="width: 100%;"
                            ></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right pt-2">
                <el-button
                    @click.prevent="close()">
                    Cancelar
                </el-button>
                <el-button
                    :loading="loading_submit"
                    dusk="submit"
                    native-type="submit"
                    type="primary">
                    <template
                        v-if="loading_submit">
                        {{ button_text }}
                    </template>
                    <template
                        v-else>
                        Guardar
                    </template>
                </el-button>
            </div>
        </form>
    </el-dialog>
</template>

<script>
import {serviceNumber} from '../../../mixins/functions'

export default {
    mixins: [serviceNumber],
    props: ['showDialog', 'recordId', 'EditLimitClient' , 'EditPaymentClientPlan'],
    data() {
        return {
            defaultProps: {
                children: 'childrens',
                label: 'description'
            },
            defaultAppsProps: {
                children: 'childrens',
                label: 'description'
            },
            headers: headers_token,
            loading_submit: false,
            loading_search: false,
            titleDialog: null,
            button_text: null,
            resource: 'clients',
            error: {},
            errors: {},
            errorLUser: {},
            limit_users: null,
            limit_documents: null,
            errorLDocument: {},
            form: {},
            url_base: null,
            plans: [],
            modules: [],
            apps: [],
            types: [],
            soap_sends: [{value: '01', text: 'Sunat'}, {value: '02', text: 'Ose'}],
            soap_types: [{id: "01", description: "Demo"}, {id: "02", description: "Producción"}],
            toggle: false,
            certificate_admin: '',
            soap_username: null,
            soap_password: null,
            collapse: 1,
            business: null,
            regex_password_client: false,

            group_golden_default: [],
            apps_golden_default: [],

            countries: [],
            departments: [],
            provinces: [],
            districts: [],
            all_provinces: [],
            all_districts: [],

            //
            fileListPfx: [],
            fileListPem: [],
            fileListKey: [],
            fileListCer: [],
            fileListP12: [],
            fileListFicha: [],
            loading_get_modules: false,
            users: [],
            sellers: [],
            id_user_logged: null,
            p12_to_pfx: false,
            password_p12_to_pfx: null,
            loading_convert_p12_to_pfx: false,
            periods: [],
        }
    },
    updated() {
        // Set default values ​​for multiple selection trees
        if (this.modules !== undefined && this.$refs.tree !== undefined) {
            // this.$refs.tree.setCheckedKeys(this.modules)
        }
    },

    computed: {
        arrayPlans() {
            let plans = this.plans.filter((plan) => plan.active)
            if (this.recordId) {
                const planSelected = this.plans.filter((plan) => plan.id === this.form.plan_id)
                if (planSelected.length) {
                    plans.push(planSelected[0])
                }
            }
            const seen = new Set();
            return plans.filter(p => (seen.has(p.id) ? false : (seen.add(p.id), true)));
        },
        limitsDisabled() {
            return this.recordId === 1 || !this.EditLimitClient
        }
    },

    async created() {
        await this.$http.get(`/${this.resource}/tables`)
            .then(response => {
                this.url_base = response.data.url_base
                this.plans = response.data.plans
                this.modules = response.data.modules
                this.apps = response.data.apps
                this.types = response.data.types
                this.certificate_admin = response.data.certificate_admin
                this.soap_username = response.data.soap_username
                this.soap_password = response.data.soap_password
                this.group_basic = response.data.group_basic
                this.group_hotel = response.data.group_hotel
                this.group_pharmacy = response.data.group_pharmacy
                this.group_restaurant = response.data.group_restaurant
                this.group_hotel_apps = response.data.group_hotel_apps
                this.group_pharmacy_apps = response.data.group_pharmacy_apps
                this.group_restaurant_apps = response.data.group_restaurant_apps
                this.regex_password_client = response.data.regex_password_client

                this.group_golden_default = response.data.group_golden_default
                this.apps_golden_default = response.data.apps_golden_default
                this.countries = response.data.countries
                this.departments = response.data.departments
                this.all_provinces = response.data.provinces
                this.all_districts = response.data.districts
                this.users = response.data.users
                this.sellers = response.data.sellers
                this.id_user_logged = response.data.id_user_logged
                this.periods = response.data.periods
            })

        await this.initForm()

        this.form.soap_username = this.soap_username
        this.form.soap_password = this.soap_password
    },
    methods: {
        FixChildren(currentObj, treeStatus) {
            let element = this.$refs.tree
            if (currentObj !== undefined) {
                let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1 is unchecked
                if (selected !== -1) {
                    this.SelectParent(currentObj, element)
                    this.FixSameValueToChild(currentObj, true, element)
                } else {
                    if (currentObj.childrens !== undefined && currentObj.childrens.length !== 0) {
                        this.FixSameValueToChild(currentObj, false, element)
                    }
                }
            }
        },
        FixAppChildren(currentObj, treeStatus) {
            let element = this.$refs.Apptree
            if (currentObj !== undefined) {
                let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1 is unchecked
                if (selected !== -1) {
                    this.SelectParent(currentObj, element)
                    this.FixSameValueToChild(currentObj, true, element)
                } else {
                    if (currentObj.childrens !== undefined && currentObj.childrens.length !== 0) {
                        this.FixSameValueToChild(currentObj, false, element)
                    }
                }
            }
        },
        //funcion fusion fixchildren
        FixSameValueToChild(treeList, isSelected, element) {
            // console.dir(element);
            if (treeList !== undefined && element !== undefined) {
                element.setChecked(treeList.id, isSelected)
                if (treeList.childrens !== undefined) {
                    for (let i = 0; i < treeList.childrens.length; i++) {
                        this.FixSameValueToChild(treeList.childrens[i], isSelected, element)
                    }
                }
            }
        },
        SelectParent(currentObj, element) {
            // console.error(element);
            if (currentObj !== undefined) {
                let currentNode = element.getNode(currentObj)
                if (currentNode.parent.key !== undefined) {
                    element.setChecked(currentNode.parent, true)
                    this.SelectParent(currentNode.parent, element)
                }
            }
        },
        initForm() {
            this.limit_users = null
            this.limit_documents = null
            this.errors = {}
            this.errorLUser = {}
            this.errorLDocument = {}
            this.form = {
                id: null,
                name: null,
                // email: null,
                email: process.env.MIX_USUARIO_SOPORTE,
                identity_document_type_id: '6',
                number: '',
                // password: null,
                password: process.env.MIX_PASSWORD_SOPORTE,
                plan_id: null,
                locked_emission: true,
                // type: null,
                type: 'admin',
                is_update: false,
                modules: [],
                apps: [],
                levels: [],
                config_system_env: true,
                soap_send_id: '01',
                soap_type_id: '01',
                soap_username: null,
                soap_password: null,
                soap_url: null,
                password_certificate: null,
                certificate: null,
                temp_path: null,
                /** Mail */
                smtp_host: 'smtp.gmail.com',
                smtp_port: 465,
                smtp_user: 'username',
                smtp_password: null,
                smtp_encryption: 'ssl',
                enable_list_product: true,

                integrated_query_client_id: null,
                integrated_query_client_secret: null,
                api_sunat_id: null,
                api_sunat_secret: null,
                sire_client_id: null,
                sire_client_secret: null,
                generate_test_invoice: false,
                delete_invoice_series: false,
                delete_ticket_series: false,
                country_id: 'PE',
                department_id: null,
                province_id: null,
                district_id: null,
                address: null,
                certificate_due: null,

                user_sol: null,
                password_sol: null,
                password_cdt: null,
                observations: null,

                pfx: null,
                temp_path_pfx: null,
                pem: null,
                temp_path_pem: null,
                key: null,
                temp_path_key: null,
                cer: null,
                temp_path_cer: null,
                p12: null,
                temp_path_p12: null,
                ficha: null,
                temp_path_ficha: null,
                logo: null,
                temp_path_logo: null,
                logo_extension: null,
                trade_name: null,
                price: 0,
                user_id: this.id_user_logged || null,
                seller_id: null,
                contact_name: null,
                contact_email: null,
                contact_whatsapp: null,
                configuration_missing_data: false,
                observations_configuration_missing_data: null,
                period_id: null,
                
                // === Límites (nuevos) ===
                limit_users: null,
                users_unlimited: false,
                limit_documents: null,
                documents_unlimited: false,
                include_sale_notes_limit_documents: false,
                establishments_limit: 0,
                establishments_unlimited: true,
                sales_limit: 0,
                sales_unlimited: true,
                include_sale_notes_sales_limit: false,
                confirm_duplicate_number: false
            }
            this.p12_to_pfx = false
            this.password_p12_to_pfx = null
            this.loading_convert_p12_to_pfx = false
        },
        create() {
            if (this.recordId) {
                this.titleDialog = 'Editar Cliente';
            } else {
                this.titleDialog = 'Nuevo Cliente';
                const preSelecteds = [];

                // poner a modules el valor de group_golden_default
                let golden_default_ids = []
                this.group_golden_default.forEach(element => {
                    golden_default_ids.push(element.id)
                })
                console.log(this.modules)
                this.modules.map(m => {
                    if (golden_default_ids.includes(m.id)) {

                        preSelecteds.push(m.id);
                        m.childrens.map(c => {
                            if (c.description !== 'Tareas programadas') {
                                preSelecteds.push(c.id);
                            }
                        });

                    }
                });

                const preAppSelecteds = [];

                let apps_golden_default_ids = []
                this.apps_golden_default.forEach(element => {
                    apps_golden_default_ids.push(element.id)
                })

                this.apps.map(m => {

                    if (apps_golden_default_ids.includes(m.id)) {
                        preAppSelecteds.push(m.id);
                        m.childrens.map(c => {
                            if (c.value !== 'alter_payment') {
                                preAppSelecteds.push(c.id);
                            }
                        });
                    }
                });
                setTimeout(() => {
                    this.$refs.tree.setCheckedKeys(preSelecteds);
                    this.$refs.Apptree.setCheckedKeys(preAppSelecteds);
                }, 1000);
            }

            if (this.recordId) {
                this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.$refs.tree.setCheckedKeys([]);
                        this.$refs.Apptree.setCheckedKeys([]);
                        this.form = response.data.data;
                        this.form.is_update = true;
                        this.form.users_unlimited     = (this.form.limit_users == 0)
                        this.form.documents_unlimited = (this.form.limit_documents == 0)
                        this.limit_users     = (this.form.users_unlimited)     ? "∞" : this.form.limit_users
                        this.limit_documents = (this.form.documents_unlimited) ? "∞" : this.form.limit_documents


                        this.buildUploadsFromForm()

                        const preSelecteds = [];
                        const preSelectedsModules = this.form.modules;
                        const preSelectedsLevels = this.form.levels;

                        const preAppSelecteds = [];
                        const preSelectedsApps = this.form.apps;
                        this.modules.map(m => {
                            if (preSelectedsModules.includes(m.id)) {
                                preSelecteds.push(m.id);
                            }
                            m.childrens.map(c => {
                                const idArray = c.id.split('-');
                                if (preSelectedsLevels.includes(parseInt(idArray[1]))) {
                                    preSelecteds.push(c.id);
                                }
                            })
                        });

                        this.apps.map(m => {
                            if (preSelectedsApps.includes(m.id)) {
                                preAppSelecteds.push(m.id);
                            }
                            m.childrens.map(c => {
                                const idArray = c.id.split('-');
                                if (preSelectedsLevels.includes(parseInt(idArray[1]))) {
                                    preAppSelecteds.push(c.id);
                                }
                            })
                        });

                        this.filterProvinces()
                        this.filterDistricts()

                        setTimeout(() => {
                            this.$refs.tree.setCheckedKeys(preSelecteds);
                            this.$refs.Apptree.setCheckedKeys(preAppSelecteds);
                        }, 1000);
                    })
            }
        },
        async submit() {
            const flag_no_register = this.form.department_id && (!this.form.province_id || !this.form.district_id)
            if (flag_no_register) {
                return this.$message.error('Debe seleccionar provincia y distrito, para poder registrar el cliente.')
            }

            const modulesAndLevelsSelecteds = this.$refs.tree.getCheckedNodes();
            const appsAndLevelsSelecteds = this.$refs.Apptree.getCheckedNodes();
            const modules = [];
            modulesAndLevelsSelecteds.map(m => {
                if (m.is_parent) {
                    modules.push(m.id);
                }
            });
            appsAndLevelsSelecteds.map(m => {
                if (m.is_parent) {
                    modules.push(m.id);
                }
            });
            const levels = [];
            modulesAndLevelsSelecteds.filter(l => {
                if (!l.is_parent) {
                    const idArray = l.id.split('-');
                    levels.push(idArray[1]);
                }
            })
            appsAndLevelsSelecteds.filter(l => {
                if (!l.is_parent) {
                    const idArray = l.id.split('-');
                    levels.push(idArray[1]);
                }
            })
            this.form.modules = modules;
            this.form.levels = levels;
            this.form.regex_password_client = this.regex_password_client

            if (modules.length < 1) {
                return this.$message.error('Debe seleccionar al menos un módulo')
            }

            if (!this.form.is_update) {
                if (this.form.certificate && !this.form.password_certificate) {
                    return this.$message.error('Si carga un certificado, es necesario ingresar el password del certificado')
                }
            } else {
                if (this.form.temp_path && !this.form.password_certificate) {
                    return this.$message.error('Si carga un certificado, es necesario ingresar el password del certificado')
                }
            }

            if (this.recordId) {
                this.form.delete_invoice_series = false
                this.form.delete_ticket_series = false
            }

            

            if (this.validateLUsers().limit_users || this.validateLDocuments().limit_documents) return

            if (!this.form.establishments_unlimited && isNaN(this.form.establishments_limit))
                return this.$message.error('Límite de establecimientos no es un número válido.')
            if (!this.form.sales_unlimited && isNaN(this.form.sales_limit))
                return this.$message.error('Límite de ventas no es un número válido.')

            this.button_text = (this.form.is_update) ? 'Actualizando cliente...' : 'Creando base de datos...'

            if (!this.form.is_update) {
            const { data } = await this.$http.get(`/${this.resource}/verify-number/${this.form.number}`)

            if (data.exists) {
                const detalle = data.records
                    .map(r => `• ${r.name} — ${r.hostname}`)
                    .join('<br>')

                try {
                    await this.$confirm(
                        `El RUC <strong>${this.form.number}</strong> ya está registrado en:<br><br>${detalle}<br><br>Esta seguro que desea crear el sistema con este mismo numero de RUC?`,
                        'Advertencia',
                        {
                            confirmButtonText: 'Crear de todos modos',
                            cancelButtonText: 'Cancelar',
                            type: 'warning',
                            dangerouslyUseHTMLString: true
                        }
                    )
                    this.form.confirm_duplicate_number = true
                } catch (e) {
                    return   // canceló: no se crea nada
                }
            }
        }

            this.loading_submit = true

            this.transform()

            await this.$http.post(`${this.resource}${(this.form.is_update ? '/update' : '')}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$eventHub.$emit('reloadData')
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response)
                        let message = error.response.data.message || 'Error al realizar la operación'
                        this.$message.error(message)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },
        close() {
            this.$emit('update:showDialog', false)
            this.resetUpload()
            this.initForm()
        },
        searchSunat() {
            this.searchServiceNumber()
        },
        errorUpload(r) {
            console.log(r)
        },
        successUpload(response) {
            if (response.success) {
                this.form.certificate = response.data.filename
                this.form.temp_path = response.data.temp_path
                const { expiration_date, is_pfx, password_invalid } = response.data.data_expiration
                if (password_invalid) {
                    this.$message.error('Contraseña del certificado incorrecto.')
                } else {
                    if (this.form.soap_type_id === '02') {
                        this.form.certificate_due = expiration_date
                    }
                }
            } else {
                this.$message.error(response.message)
            }
        },
        searchNumber(data) {
            this.form.name = data.name;
            this.form.trade_name = data.name

            this.form.department_id = data.location_id[0]
            this.filterProvince()
            this.form.province_id = data.location_id[1]
            this.filterDistricts()
            this.form.district_id = data.location_id[2]
            this.form.address = data.address
        },
        changeModules() {
            var group = {
                modules: [],
                apps: [],
            };
            if(this.business == 1){
                group.modules = this.getIds(this.group_basic);
            }
            if(this.business == 2){
                group.modules = this.getIds(this.group_pharmacy);
                group.apps = this.getIds(this.group_pharmacy_apps);
            }
            if(this.business == 3){
                group.modules = this.getIds(this.group_hotel);
                group.apps = this.getIds(this.group_hotel_apps);
            }
            if(this.business == 4){
                group.modules = this.getIds(this.group_restaurant);
                group.apps = this.getIds(this.group_restaurant_apps);
            }
            this.$refs.tree.setCheckedKeys(group.modules);
            this.$refs.Apptree.setCheckedKeys(group.apps);
        },
        getIds(modules) {
            const preSelecteds = [];
            modules.map(m => {
                preSelecteds.push(m.id);
                m.childrens.map(c => {
                    preSelecteds.push(c.id);
                });
            });
            return preSelecteds
        },

        changeSoapSend() {
            if (this.form.soap_send_id == '01' && this.form.soap_type_id == '02') { // sunat y producccion
                this.form.soap_username = process.env.MIX_SUNAT_USER
                this.form.soap_password = process.env.MIX_SUNAT_PASSWORD
                this.form.soap_url = null
            } else if (this.form.soap_send_id == '02' && this.form.soap_type_id == '02') { // ose nubefact y producccion
                this.form.soap_username = process.env.MIX_OSE_NUBEFACT_USER
                this.form.soap_password = process.env.MIX_OSE_NUBEFACT_PASSWORD
                this.form.soap_url = process.env.MIX_OSE_NUBEFACT_URL
            } else {
                this.form.soap_username = null
                this.form.soap_password = null
                this.form.soap_url = null
            }
        },

        filterProvince() {
            this.form.province_id = null
            this.form.district_id = null
            this.filterProvinces()
        },

        filterProvinces() {
            this.provinces = this.all_provinces.filter(p => {
                return p.department_id === this.form.department_id
            })
        },

        filterDistrict() {
            this.form.district_id = null
            this.filterDistricts()
        },

        filterDistricts() {
            this.districts = this.all_districts.filter(d => {
                return d.province_id === this.form.province_id
            })
        },

        beforeUploadPfx(file) {
            const isValid = file.name.endsWith('.pfx')
            if (!isValid) {
                this.$message.error('El archivo debe ser .pfx')
            }
            return isValid
        },

        successUploadPfx(response) {
            if (response.success) {
                this.form.pfx = response.data.filename
                this.form.temp_path_pfx = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removePfx(file, fileList) {
            this.form.pfx = null
            this.form.temp_path_pfx = null
        },

        beforeUploadPem(file) {
            const isValid = file.name.endsWith('.pem')
            if (!isValid) {
                this.$message.error('El archivo debe ser .pem')
            }
            return isValid
        },

        successUploadPem(response) {
            if (response.success) {
                this.form.pem = response.data.filename
                this.form.temp_path_pem = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removePem(file, fileList) {
            this.form.pem = null
            this.form.temp_path_pem = null
        },

        beforeUploadKey(file) {
            const isValid = file.name.endsWith('.key')
            if (!isValid) {
                this.$message.error('El archivo debe ser .key')
            }
            return isValid
        },

        successUploadKey(response) {
            if (response.success) {
                this.form.key = response.data.filename
                this.form.temp_path_key = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removeKey(file, fileList) {
            this.form.key = null
            this.form.temp_path_key = null
        },

        beforeUploadCer(file) {
            const isValid = file.name.endsWith('.cer')
            if (!isValid) {
                this.$message.error('El archivo debe ser .cer')
            }
            return isValid
        },

        successUploadCer(response) {
            if (response.success) {
                this.form.cer = response.data.filename
                this.form.temp_path_cer = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removeCer(file, fileList) {
            this.form.cer = null
            this.form.temp_path_cer = null
        },

        beforeUploadP12(file) {
            const isValid = file.name.endsWith('.p12')
            if (!isValid) {
                this.$message.error('El archivo debe ser .p12')
            }
            return isValid
        },

        successUploadP12(response) {
            if (response.success) {
                this.form.p12 = response.data.filename
                this.form.temp_path_p12 = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removeP12(file, fileList) {
            this.form.p12 = null
            this.form.temp_path_p12 = null
        },

        beforeUploadFicha(file) {
            const isValid = file.name.endsWith('.pdf')
            if (!isValid) {
                this.$message.error('El archivo debe ser .pdf')
            }
            return isValid
        },

        successUploadFicha(response) {
            if (response.success) {
                this.form.ficha = response.data.filename
                this.form.temp_path_ficha = response.data.temp_path
            } else {
                this.$message.error(response.message)
            }
        },

        removeFicha(file, fileList) {
            this.form.ficha = null
            this.form.temp_path_ficha = null
        },

        beforeUploadLogo(file) {
            const allowedTypes = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp']
            const ext = file.name.slice(file.name.lastIndexOf('.'))
            const isValid = allowedTypes.includes(ext)
            if (!isValid) {
                this.$message.error('Solo se permiten archivos de imagen')
            }
            return isValid
        },

        successUploadLogo(response) {
            if (response.success) {
                this.form.logo = response.data.filename
                this.form.temp_path_logo = response.data.temp_path
                this.form.logo_extension = response.data.extension
            } else {
                this.$message.error(response.message)
            }
        },

        buildUploadsFromForm() {
            // PFX
            if (this.form.pfx) {
                this.fileListPfx = [
                    {
                    name: this.form.pfx,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'pfx-' + Date.now()
                    }
                ]
            }
            // PEM
            if (this.form.pem) {
                this.fileListPem = [
                    {
                    name: this.form.pem,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'pem-' + Date.now()
                    }
                ]
            }
            // key
            if (this.form.key) {
                this.fileListKey = [
                    {
                    name: this.form.key,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'key-' + Date.now()
                    }
                ]
            }
            // cer
            if (this.form.cer) {
                this.fileListCer = [
                    {
                    name: this.form.cer,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'cer-' + Date.now()
                    }
                ]
            }
            // p12
            if (this.form.p12) {
                this.fileListP12 = [
                    {
                    name: this.form.p12,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'p12-' + Date.now()
                    }
                ]
            }
            // ficha
            if (this.form.ficha) {
                this.fileListFicha = [
                    {
                    name: this.form.ficha,
                    status: 'success',
                    // si tienes una ruta pública:
                    // url: `/tenancy-next-file/${this.form.pfx}`,
                    uid: 'ficha-' + Date.now()
                    }
                ]
            }
        },

        downloadFile(filename) {
            window.open(
                `/download-customer-data/${this.recordId}/${filename}`,
                "_blank"
            );
        },

        resetUpload() {
            this.$refs.uploadPfx.clearFiles()
            this.$refs.uploadPem.clearFiles()
            this.$refs.uploadKey.clearFiles()
            this.$refs.uploadCer.clearFiles()
            this.$refs.uploadP12.clearFiles()
            this.$refs.uploadFicha.clearFiles()
        },

        async getModules() {
            const plan = this.plans.find(plan => plan.id === this.form.plan_id)
            this.form.price = plan.pricing || 0
            this.form.period_id = plan.period_id || null

            // Límites según el plan seleccionado
            this.form.limit_users     = plan.limit_users
            this.form.limit_documents = plan.limit_documents

            // Flags derivados (0 = ilimitado)
            this.form.users_unlimited     = (plan.limit_users == 0)
            this.form.documents_unlimited = (plan.limit_documents == 0)

            // Valor mostrado en el input ("∞" si es ilimitado)
            this.limit_users     = (this.form.users_unlimited)     ? "∞" : plan.limit_users
            this.limit_documents = (this.form.documents_unlimited) ? "∞" : plan.limit_documents

            this.form.include_sale_notes_limit_documents = plan.include_sale_notes_limit_documents

            this.form.establishments_limit               = plan.establishments_limit
            this.form.establishments_unlimited           = plan.establishments_unlimited

            this.form.sales_limit                        = plan.sales_limit
            this.form.sales_unlimited                    = plan.sales_unlimited
            this.form.include_sale_notes_sales_limit     = plan.include_sale_notes_sales_limit

            // Flags derivados (0 = ilimitado, igual que en el formulario de planes)
            this.form.users_unlimited     = (plan.limit_users == 0)
            this.form.documents_unlimited = (plan.limit_documents == 0)
            
            this.business = null
            try {
                this.loading_get_modules = true
                const response = await this.$http.get(`/plans/modules/${this.form.plan_id}`)
                let modules = response.data.modules
                let apps = response.data.apps
                this.$refs.tree.setCheckedKeys(modules)
                this.$refs.Apptree.setCheckedKeys(apps)
            } catch (error) {
                if (error.response) {
                    let message = error.response.data.message || 'Error al realizar la operación'
                    this.$message.error(message)
                }
            } finally {
                this.loading_get_modules = false
            }
        },

        async assignExpirationDate() {
            if (this.form.temp_path) {
                try {
                    const { data } = await this.$http.post('/clients/expiration-date', {
                        extension: 'pfx',
                        temp_path: this.form.temp_path,
                        password: this.form.password_certificate
                    })
                    const { expiration_date, is_pfx, password_invalid } = data.data
                    if (password_invalid) {
                        this.$message.error('Contraseña del certificado incorrecto.')
                    } else {
                        if (this.form.soap_type_id === '02') {
                            this.form.certificate_due = expiration_date
                        }
                    }
                } catch (error) {}
            }
        },

        async convertP12ToPfx() {
            if (!this.form.p12 && !this.form.temp_path_p12) {
                this.$message.error('Debe cargar un archivo p12, para realizar la conversión a pfx.')
                return
            }
            if (!this.password_p12_to_pfx) {
                this.$message.error('Debes ingresar una contraseña, para realizar la conversión a pfx.')
                return
            }
            try {
                this.loading_convert_p12_to_pfx = true
                const response = await this.$http.post('/clients/generate-p12-to-pfx', {
                    client_id: this.recordId,
                    p12: this.form.temp_path_p12,
                    p12_filename: this.form.p12,
                    pfx_filename: this.form.pfx,
                    password: this.password_p12_to_pfx
                })

                if (response.data.success) {
                    const { data } = response
                    this.form.cer = data.data.cer.name
                    this.form.temp_path_cer = data.data.cer.path
                    
                    this.form.key = data.data.key.name
                    this.form.temp_path_key = data.data.key.path

                    this.form.pfx = data.data.pfx.name
                    this.form.temp_path_pfx = data.data.pfx.path

                    this.fileListCer = [
                        {
                            name: this.form.cer,
                            status: 'success',
                            // si tienes una ruta pública:
                            // url: `/tenancy-next-file/${this.form.pfx}`,
                            uid: 'cer-' + Date.now()
                        }
                    ]

                    this.fileListKey = [
                        {
                            name: this.form.key,
                            status: 'success',
                            // si tienes una ruta pública:
                            // url: `/tenancy-next-file/${this.form.pfx}`,
                            uid: 'key-' + Date.now()
                        }
                    ]

                    this.fileListPfx = [
                        {
                            name: this.form.pfx,
                            status: 'success',
                            // si tienes una ruta pública:
                            // url: `/tenancy-next-file/${this.form.pfx}`,
                            uid: 'pfx-' + Date.now()
                        }
                    ]

                    this.$message.success(response.data.message)

                    // this.form.password_certificate = this.password_p12_to_pfx
                    this.$set(this.form, 'password_certificate', this.password_p12_to_pfx)

                    this.form.certificate = data.data.pfx.name
                    this.form.temp_path = data.data.pfx.path
                    if (this.form.soap_type_id == '02') {
                        await this.assignExpirationDate()
                    }
                } else {
                    this.$message.error(response.data.message)
                }
            } catch (error) {
                this.$message.error('Error al realizar la operación.')
            } finally {
                this.loading_convert_p12_to_pfx = false
            }
        },
            validateLDocuments(){

                this.errorLDocument = {} 

                if(!this.form.documents_unlimited){
                    if(this.limit_documents < 1)
                        this.$set(this.errorLDocument, 'limit_documents', ['limite de documentos debe ser mayor a cero']);
                } 

                return this.errorLDocument 
            },            
            
            validateLUsers(){

                this.errorLUser = {}  
                 
                if(!this.form.users_unlimited){
                    if(this.limit_users < 1)
                        this.$set(this.errorLUser, 'limit_users', ['limite de usuarios debe ser mayor a cero']);
                }

                return this.errorLUser 
            },
            setUnlimitUsers(){
                this.limit_users = (this.form.users_unlimited) ? "∞" : null
                this.form.limit_users = (this.limit_users == "∞") ? 0 : this.limit_users

            },
            setUnlimitDocuments(){
                this.limit_documents = (this.form.documents_unlimited) ? "∞" : null
                this.form.limit_documents = (this.limit_documents == "∞") ? 0 : this.limit_documents
            },
            transform(){
                this.form.limit_users     = (this.form.users_unlimited)     ? 0 : this.limit_users
                this.form.limit_documents = (this.form.documents_unlimited) ? 0 : this.limit_documents
            },
    }
}
</script>

<style scoped>
    .card-header-no-radius {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    .card-body-no-radius {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/clients/form.vue